import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../../atoms/CollectionTitle";
import StoryCard from "../StoryCard";

import "./second-collection.m.css";

const SecondCollection = ({ collectionItem, associatedMetadata, sectionSlug }) => {
  const showRowTitle = associatedMetadata.show_row_title || null;
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const showSubHeadline = associatedMetadata.show_sub_headline || null;
  const { items } = collectionItem;
  const firstStory = get(items, ["0", "story"]);

  return (
    <div styleName="collection-two">
      {showRowTitle && (
        <CollectionTitle
          collection={collectionItem}
          enableSponsorAd={enableSponsorAd}
          sponsorAdDetails={sponsorAdDetails}
          sectionSlug={sectionSlug}
        />
      )}
      <StoryCard
        story={firstStory}
        associatedMetadata={associatedMetadata}
        isHorizontal={true}
        isHeroStory={true}
        showTimeStamp={showTimeStamp}
        showReadTime={showReadTime}
        showSubHeadline={showSubHeadline}
        sectionSlug={sectionSlug}
      />
    </div>
  );
};

SecondCollection.propTypes = {
  collectionItem: PropTypes.object,
  associatedMetadata: PropTypes.object,
  sectionSlug: PropTypes.string,
};

SecondCollection.storyLimit = 1;

export default SecondCollection;
